import { useState, ReactNode } from 'react';

import { Box, Tooltip } from '@mui/material';

const TooltipButton = ({ text = 'Copiado', children, disabled = false }: { text?: string; children: ReactNode; disabled?: boolean; }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleCopied = () => {
        setIsOpen(true);
        setTimeout(() => {
            setIsOpen(false);
        }, 1500);
    }

    return (
        <Tooltip
            PopperProps={{
                disablePortal: true,
            }}
            open={isOpen}
            placement="top"
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={text}
            onClick={() => !disabled && handleCopied()}
        >
            <Box>
                {children}
            </Box>
        </Tooltip>
    )
}

export default TooltipButton;